var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize.initial",
          value: _vm.handleResize,
          expression: "handleResize",
          modifiers: { initial: true }
        }
      ],
      staticClass: "columns is-centered "
    },
    [
      _c(
        "div",
        {
          staticClass: "column is-10-desktop is-12-mobile is-12-tablet",
          attrs: { id: "confirmation-page" }
        },
        [
          _vm.useSmallLogo
            ? _c(
                "div",
                { staticClass: "simple-header" },
                [_c("header-logo")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userAvailable
            ? _c("h4", { staticClass: "is-size-4" }, [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.trackingText) + "\n\t\t\t\t"),
                !_vm.loggedIn
                  ? _c(
                      "a",
                      {
                        staticClass: "store-navigation-color",
                        attrs: { href: "/?login" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.showModal("login")
                          }
                        }
                      },
                      [_vm._v("\n\t\t\t\t\tcreate your account\n\t\t\t\t")]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.userUnavailable
            ? _c("div", [
                _c("p", { staticClass: "is-size-5" }, [
                  _vm._v("Please login to see your receipt")
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "store-navigation-color",
                    attrs: { href: "/?login" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.showModal("login")
                      }
                    }
                  },
                  [_vm._v("Show login screen")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.msg
            ? _c("p", { staticClass: "is-size-5" }, [
                _vm._v(
                  "\n                " + _vm._s(_vm.msg) + "\n            "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.orderMap.origin && _vm.orderId && _vm.recentOrder
            ? _c("order-tracker", {
                attrs: {
                  orderLocation: _vm.orderMap.origin,
                  order: _vm.recentOrder
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "columns", attrs: { id: "order-info" } }, [
            _c(
              "div",
              { staticClass: "column is-7-desktop is-12-mobile is-12-tablet" },
              [
                _c("div", { attrs: { id: "destination-description" } }, [
                  _vm.recentOrder &&
                  _vm.recentOrder.serviceType ===
                    _vm.EServiceType.SERVICE_TYPE_DELIVERY
                    ? _c("div", { staticClass: "padded-section" }, [
                        _c(
                          "h5",
                          {
                            staticClass: "is-size-5-5 is-bold",
                            attrs: {
                              tabindex: "0",
                              "aria-label":
                                "deliver to " + _vm.displayFullAddress()
                            }
                          },
                          [_vm._v("Delivery Address")]
                        ),
                        _vm._v(
                          "  \n                            " +
                            _vm._s(_vm.displayFullAddress()) +
                            "\n                        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orderMap.origin && _vm.recentOrder
                    ? _c("div", { staticClass: "padded-section" }, [
                        _c(
                          "h5",
                          {
                            staticClass: "is-size-5-5 is-bold",
                            attrs: {
                              tabindex: "0",
                              "aria-label":
                                "order at store: " + _vm.orderMap.origin.name
                            }
                          },
                          [_vm._v("Store")]
                        ),
                        _vm._v(
                          "  \n                            " +
                            _vm._s(_vm.orderMap.origin.name)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.orderMap.origin.address) +
                            "\n                            "
                        ),
                        _vm.orderMap.origin && _vm.storePhone
                          ? _c("p", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    "aria-label":
                                      "if you would like to contact the store call: " +
                                      _vm.storePhone,
                                    href:
                                      "tel:" + _vm.orderMap.origin.contactPhone
                                  }
                                },
                                [_vm._v(_vm._s(_vm.storePhone))]
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.orderMap.origin !== null &&
                _vm.$mq === "mobile" &&
                _vm.appLoaded
                  ? _c(
                      "div",
                      [
                        _c("BaseMap", {
                          attrs: {
                            zoom: 12,
                            storeLocation: _vm.orderMap.origin,
                            directions:
                              _vm.recentOrder.serviceType ===
                                _vm.EServiceType.SERVICE_TYPE_DELIVERY &&
                              _vm.orderMap.destination &&
                              _vm.orderMap.origin
                                ? _vm.orderMap
                                : null,
                            height: "550px;"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.recentOrder
                  ? _c("p", { staticClass: "is-bold" }, [
                      _c("span", { staticClass: "is-size-5" }, [
                        _vm._v("Your Order: #" + _vm._s(_vm.getOrderId))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "is-pulled-right store-navigation-color is-clickable",
                          on: { click: _vm.clickEmailReceipt }
                        },
                        [_vm._v("Email receipt")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.recentOrder
                  ? [
                      _vm._l(_vm.recentOrder.items, function(item, index) {
                        return _c("checkout-item", {
                          key: index,
                          attrs: {
                            index: index,
                            isMinified: true,
                            isRecentOrder: true,
                            item: item
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm.recentOrder.orderNotes
                        ? _c("p", [
                            _vm._v(
                              "\n                            Instructions: "
                            ),
                            _c("i", [
                              _vm._v(_vm._s(_vm.recentOrder.orderNotes))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "checkout-total is-size-6",
                          attrs: { tabindex: "0" }
                        },
                        _vm._l(_vm.streamLinedTotals(), function(value, key) {
                          return _c("p", { key: key }, [
                            _c("span", { staticClass: "is-bold" }, [
                              _vm._v(_vm._s(_vm.startCase(key)))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "is-pulled-right has-text-grey" },
                              [_vm._v(_vm._s(_vm.centsToDollars(value)))]
                            )
                          ])
                        }),
                        0
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "column" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column is-5-desktop is-12-mobile is-12-tablet" },
              [
                _vm.orderMap.origin !== null &&
                _vm.$mq !== "mobile" &&
                _vm.appLoaded
                  ? _c(
                      "div",
                      [
                        _c("BaseMap", {
                          attrs: {
                            zoom: 12,
                            storeLocation: _vm.orderMap.origin,
                            directions:
                              _vm.recentOrder.serviceType ===
                                _vm.EServiceType.SERVICE_TYPE_DELIVERY &&
                              _vm.orderMap.destination &&
                              _vm.orderMap.origin
                                ? _vm.orderMap
                                : null,
                            height: "550px;"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d5581ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d5581ec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/OrderConfirmation.vue
// module id = null
// module chunks = 